import React, { useState } from "react";
import { RecBar, RecField, RecIcon } from "../../materials/MaterialRecordParts";
import { PRIORITY_OPTIONS, validateTaskInput } from "../../../helpers/tasks/taskModel";
import { TASK_ACTION } from "../../../taskIntelligence/taskDraftModel";

/** Inline quick edit for one draft — not yet a real task, so Save only updates local review state. */
export function TaskDraftQuickEdit({ draft, members, locations, onSave, onCancel }) {
  const [title, setTitle] = useState(draft.title);
  const [description, setDescription] = useState(draft.description || "");
  const [assigneeId, setAssigneeId] = useState(draft.assigneeId || "");
  const [dueDate, setDueDate] = useState(draft.dueDate || "");
  const [priority, setPriority] = useState(draft.priority || "");
  const [locationId, setLocationId] = useState(draft.locationId || "");
  const [errors, setErrors] = useState({});

  const isClarify = draft.action === TASK_ACTION.CLARIFY;

  function save() {
    const result = validateTaskInput({ title, description, priority, dueDate });
    if (!result.ok) {
      setErrors(result.errors);
      return;
    }
    onSave({ title, description, assigneeId, dueDate, priority, locationId });
  }

  return (
    <div className="screen nx-screen rec-page tbl-screen" data-testid="task-draft-quick-edit">
      <RecBar title="Quick Edit" onBack={onCancel} />
      <div className="tbl-body">
        {isClarify ? (
          <div className="tk-notice" role="status">
            {draft.clarifyPrompt}
          </div>
        ) : null}
        {draft.evidence ? <div className="tbl-evidence">"{draft.evidence}"</div> : null}

        <RecField label="Title" htmlFor="qe-title" required error={errors.title}>
          <input id="qe-title" className="rec-input" value={title} onChange={(e) => setTitle(e.target.value)} />
        </RecField>

        <RecField label="Description" htmlFor="qe-desc" error={errors.description}>
          <textarea id="qe-desc" className="rec-input" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
        </RecField>

        <RecField label="Assignee" htmlFor="qe-assignee" icon="user">
          <select id="qe-assignee" className="rec-input" value={assigneeId} onChange={(e) => setAssigneeId(e.target.value)}>
            <option value="">Unassigned</option>
            {members.map((m) => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
        </RecField>

        <RecField label="Due Date" htmlFor="qe-due" icon="calendar" error={errors.dueDate}>
          <input id="qe-due" className="rec-input" type="date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} />
        </RecField>

        <RecField label="Priority" htmlFor="qe-priority" icon="flag" error={errors.priority}>
          <select id="qe-priority" className="rec-input" value={priority} onChange={(e) => setPriority(e.target.value)}>
            {PRIORITY_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </RecField>

        {locations.length ? (
          <RecField label="Location" htmlFor="qe-location" icon="pin">
            <select id="qe-location" className="rec-input" value={locationId} onChange={(e) => setLocationId(e.target.value)}>
              <option value="">No location</option>
              {locations.map((l) => (
                <option key={l.id} value={l.id}>
                  {l.name}
                </option>
              ))}
            </select>
          </RecField>
        ) : null}
      </div>
      <div className="rec-actions">
        <button type="button" className="rec-btn rec-btn--ghost" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="rec-btn rec-btn--primary" onClick={save}>
          <RecIcon name="check" /> Save
        </button>
      </div>
    </div>
  );
}
